/** Target POS viewport for salon terminals (see docs/POS-VIEWPORT-AUDIT.md). */
export const POS_VIEWPORT = {
  width: 1366,
  height: 768,
}

/** AppShell top bar height (single row). Used for layout math / docs. */
export const POS_SHELL_HEADER_PX = 68

/** Horizontal padding inside POS shell (px-4 / lg:px-8). */
export const POS_SHELL_HORIZONTAL_PX = 32

export const POS_PANEL_IDS = {
  catalog: 'pos-panel-catalog',
  cart: 'pos-panel-cart',
  customer: 'pos-panel-customer',
}

/** Fixed width of the category sidebar at 1366px (CSS uses clamp; see .pos-v2-shell). */
export const POS_LEFT_SIDEBAR_PX = 240

/** Fixed width of the right column at 1366px (CSS uses clamp; see .pos-v2-shell). */
export const POS_RIGHT_PANEL_PX = 384

/** Design-time grid template at 1366px; live layout uses CSS variables in index.css. */
export const POS_GRID_COLUMNS = `${POS_LEFT_SIDEBAR_PX}px minmax(0, 1fr) ${POS_RIGHT_PANEL_PX}px`

/** Ticket vs catalog split inside center column (percent). */
export const POS_CENTER_TICKET_FR = 42
export const POS_CENTER_PICKER_FR = 58

/**
 * Available vertical space for POS panels below AppShell header.
 * @param {number} [viewportHeight]
 */
export function computePosAvailableHeight(viewportHeight = POS_VIEWPORT.height) {
  return viewportHeight - POS_SHELL_HEADER_PX - 12
}

/**
 * @param {number} [viewportWidth]
 */
export function computePosContentWidth(viewportWidth = POS_VIEWPORT.width) {
  return viewportWidth - POS_SHELL_HORIZONTAL_PX * 2
}
